module.exports = __webpack_public_path__ + "img/umbrella-beach.fd1b2df4.svg";